export default __webpack_public_path__ + "static/media/05.3a862a94.jpg";